import HTTP from '@/common/HTTP'
import { mutationTypes, actionTypes } from './AccountSettingsTypes'

function initialState() {
  return {
    twoFa: null,
    user: null,
  }
}

const mutations = {
  [mutationTypes.SET_2FA_DATA](state, data) {
    state.twoFa = data
  },
  [mutationTypes.SET_USER_DATA](state, user) {
    state.user = user
  },
}

const actions = {
  [actionTypes.FETCH_USER_DATA]({ state, commit }) {
    return HTTP.get('/users/me').then(({ data }) => {
      commit(mutationTypes.SET_USER_DATA, data)
      return state
    })
  },
  [actionTypes.UPDATE_USER_DATA]({ commit, state }, user) {
    return HTTP.patch('/users/me', user).then(() => {
      commit(mutationTypes.SET_USER_DATA, user)
      return state
    })
  },
  [actionTypes.CHANGE_PASSWORD]({ commit, state }, passwordChangeObject) {
    return HTTP.patch('/users/me/change-password', passwordChangeObject)
  }
}

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/AccountSettings.js